export const MODAL_TYPE_CREATE_COMMENT = 'create-comment';
